// work data

export const Work = [
    {
        id:1,
        name:"T-Shirt Customization",
        description:"It is build on top of the React JS, with styledComponents and GSAP for smooth scrolling animations.",
        tags:["react","gsap","styledComponents"],
        
        demo:"https://sabari-tshirt.netlify.app",
        github:"https://github.com/SAB1825/Project2"
    },
    {
        id:2,
        name:"A stunning portfolio website",
        description:"A stunning portfolio website using reactjs.",
        tags:["react","sass"],
        
        demo:"http://react-job-listing-website.codebucks27.vercel.app/",
        github:"https://github.com/SAB1825/proj"
        
    },
    {
        id:3,
        name:"Fitness app",
        description:"A fitness app build by using nodejs and getting information from rapid api.",
        tags:["react","api","sass"],
        
        demo:"https://sabari-fitness.netlify.app",
        github:"https://github.com/SAB1825/gym"
    }
]